
  export default {
    name: 'ThemeStoresMobileAndroid'
  }
